module.exports = __webpack_public_path__ + "88ab9cf94ff707b265d83b587d15265b.pdf";